import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "../../../lib/utils";
import { ComponentProps } from "react";

const countBadgeVariants = cva(
  "inline-flex h-[15px] min-w-[18px] items-center justify-center rounded px-1 text-[12px] leading-[11px] font-medium",
  {
    variants: {
      tone: {
        dark: "bg-innoveraZinc-900 text-white",
        muted: "bg-innoveraZinc-150 text-innoveraZinc-500"
      }
    },
    defaultVariants: {
      tone: "dark"
    }
  }
);

export type TCountBadgeProps = ComponentProps<"span"> & VariantProps<typeof countBadgeVariants>;

export function CountBadge({ className, tone, ...props }: TCountBadgeProps) {
  return <span data-slot="count-badge" className={cn(countBadgeVariants({ tone }), className)} {...props} />;
}
